import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/duration-calendar-days-list';
import AggregateNumber from "../../aggregate/aggregate-number";
import AggregateDurationComponent from "./components/aggregate-duration";

export default class DurationCalendarDaysField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.DURATION_CALENDAR_DAYS;
        this.valueType = gd.const.fields.valueType.FLOAT;
        this.formulaCompatible = true;
    }

    static getValue(item) {
        return item.durationCalendar
    }

    get sortHintMessage() {
        return 'Sort by duration calendar days';
    }

    getCsvValue(item) {
        return DurationCalendarDaysField.getValue(item);
    }

    getValue(item, params) {return DurationCalendarDaysField.getValue(item)}

    getAggregateClass() {return AggregateNumber}
    getAggregateOptions() {return [
        gd.const.aggregate.type.SUM,
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.MEDIAN,
        gd.const.aggregate.type.AVERAGE
    ]}

    listItemSortFunctions(sort) {
        return {
            functions: [i => DurationCalendarDaysField.getValue(i.item) || 0],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null);
    }

    get AggregateComponent() {
        return AggregateDurationComponent.bind(null, this.getAggregateOptions());
    }
}